import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import Authcontext from './Cotext/Authcontext';


function Header({title="CMS"}) {
  const {user,setuser}=useContext(Authcontext);
  return (

    <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
    <div className="container-fluid">
      <Link to="/">
        <a className="navbar-brand">{title}</a>
      </Link>

      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarColor01"
        aria-controls="navbarColor01"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

        <div className="collapse navbar-collapse" id="navbarColor01">
          <ul className="navbar-nav ms-auto">
         
          {user ? (
              <>
                <li className="nav-item">
                  <Link to="/mycontacts">
                    <a className="nav-link">All Contacts</a>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/create">
                    <a className="nav-link">Create</a>
                  </Link>
                </li>
                <li
                  className="nav-item"
                  onClick={() => {
                    setuser(null);
                    localStorage.clear();
                  
                 
                  }}
                >
                  <button className="btn btn-danger">Logout</button>
                </li>
              </>
            ) : (
              <>
                <li className="nav-item">
                  <Link to="/login">
                    <a className="nav-link">Login</a>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/register">
                    <a className="nav-link">Register</a>
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    
    </nav>

 
  )
}

export default Header